(function (window, document) {
  const lensDetailsContainers = Array
    .from(document.querySelectorAll('.lens-detail'));
  // If there are fewer than 2 lens details components on the page, do nothing.
  if (lensDetailsContainers.length < 2) return;

  init();

  /**
   * Instantiate lens details switch behavior.
   */
  function init() {
    // Hide all but the first one on the page.
    lensDetailsContainers.slice(1).forEach((container) => {
      container.classList.add('js-hidden');
    });

    if (window.componentEvents) {
      window.componentEvents
        .on('swatch-list-update', updateLensDetailVisibility);
    }
  }

  /**
   * Update visibility of lens-detail containers according to the lens color
   * selected by the user.
   */
  function updateLensDetailVisibility(data) {
    // If lens color hasn’t changed, do nothing.
    if (data.feature !== 'lens-color') return;
    const selectedLensColorId = data.swatch.dataset.lensColorId;
    lensDetailsContainers.forEach(function (container) {
      if (container.dataset.lensColorId === selectedLensColorId) {
        container.classList.remove('js-hidden');
      } else {
        container.classList.add('js-hidden');
      }
    });
  }
})(window, document);
